import { CommandParameterDTO, CommandParametersType, FormCommand, GETCommand } from '@types'

/**
 * Convert GETCommand to FormCommand for use in  forms
 */
export function convertGETCommandToFormCommand(getCommand: GETCommand): FormCommand {
  return {
    internalId: getCommand.internalId || Date.now().toString(),
    type: null,
    name: {
      id: getCommand.name,
      label: getCommand.name,
      httpMethod: getCommand.httpMethod,
    },
    httpMethod: getCommand.httpMethod,
    resource: getCommand.resource,
    sourceCommand: {
      id: getCommand.objectCode,
      label: getCommand.objectTitle || getCommand.objectCode,
      code: getCommand.objectCode,
      typeResource: getCommand.resource,
    },
    sourceType: {
      id: getCommand.resource || 'OBJECT',
      label: getCommand.resource || 'OBJECT',
    },
    objectCode: null,
    parameters: (getCommand.parameters || []).map(convertParameterDTOToParametersType),
    body: (getCommand.body || []).map(convertParameterDTOToParametersType),
  }
}

/**
 * Convert FormCommand to GETCommand for saving
 */
export function convertFormCommandToGETCommand(formCommand: FormCommand): GETCommand {
  const name =
    typeof formCommand.name === 'object' ? formCommand.name?.id || '' : formCommand.name || ''
  const objectCode =
    typeof formCommand.sourceCommand === 'object'
      ? formCommand.sourceCommand?.id || formCommand.sourceCommand?.code || ''
      : typeof formCommand.objectCode === 'object'
      ? formCommand.objectCode?.id || ''
      : formCommand.objectCode || ''

  const objectTitle =
    typeof formCommand.sourceCommand === 'object'
      ? formCommand.sourceCommand?.label || objectCode
      : objectCode

  const httpMethod =
    typeof formCommand.name === 'object' && formCommand.name?.httpMethod
      ? formCommand.name.httpMethod
      : formCommand.httpMethod || 'GET'

  const resource =
    typeof formCommand.sourceType === 'object'
      ? formCommand.sourceType?.id
      : formCommand.resource || 'OBJECT'

  return {
    internalId: formCommand.internalId || Date.now().toString(),
    type: typeof formCommand.type === 'object' ? formCommand.type?.id : formCommand.type,
    name,
    objectCode,
    objectTitle,
    httpMethod,
    resource,
    parameters: (formCommand.parameters || []).map(convertParametersTypeToParameterDTO),
    body: (formCommand.body || []).map(convertParametersTypeToParameterDTO),
  }
}

/**
 * Convert CommandParameterDTO to CommandParametersType
 */
function convertParameterDTOToParametersType(param: CommandParameterDTO): CommandParametersType {
  return {
    id: param.id,
    title: param.title ? { id: param.title, label: param.title } : null,
    type: param.type ? { id: param.type, label: param.type } : null,
    objectCode: param.objectCode ? { id: param.objectCode, label: param.objectCode } : null,
    objectTitle: param.objectTitle,
    value: param.value,
    pathArray: param.pathArray,
  }
}

/**
 * Convert CommandParametersType to CommandParameterDTO
 */
function convertParametersTypeToParameterDTO(param: CommandParametersType): CommandParameterDTO {
  return {
    id: param.id,
    title: typeof param.title === 'object' ? param.title?.label || '' : param.title || '',
    type: typeof param.type === 'object' ? param.type?.id || 'STATIC' : param.type || 'STATIC',
    objectCode:
      typeof param.objectCode === 'object'
        ? param.objectCode?.id || null
        : param.objectCode || null,
    objectTitle: param.objectTitle,
    value: param.value,
    pathArray: param.pathArray,
  }
}

/**
 * Convert array of GETCommands to FormCommands
 */
export function convertGETCommandsToFormCommands(
  commands: GETCommand[] | null | undefined
): FormCommand[] {
  if (!commands || !Array.isArray(commands)) {
    return []
  }

  return commands.map(convertGETCommandToFormCommand)
}

/**
 * Convert array of FormCommands to GETCommands
 */
export function convertFormCommandsToGETCommands(
  commands: FormCommand[] | null | undefined
): GETCommand[] {
  if (!commands || !Array.isArray(commands)) {
    return []
  }

  return commands.map(convertFormCommandToGETCommand)
}
